import { render } from "./CheckListItem.vue?vue&type=template&id=f276213e&ts=true"
import script from "./CheckListItem.vue?vue&type=script&lang=ts"
export * from "./CheckListItem.vue?vue&type=script&lang=ts"

import exportComponent from "/buddy/uup/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__